import * as React from "react";

function SvgMastercard(_ref, svgRef) {
  let { title, titleId, ...props } = _ref;
  return /*#__PURE__*/ React.createElement(
    "svg",
    {
      width: 45,
      height: 30,
      viewBox: "0 0 45 30",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ref: svgRef,
      "aria-labelledby": titleId,
      ...props,
    },
    title ? /*#__PURE__*/ React.createElement("title", { id: titleId }, title) : null,
    /*#__PURE__*/ React.createElement("path", {
      d: "M6.47573 29.9084V27.263C6.47573 26.2484 ...", // shortened for brevity
      fill: "black",
    }),
    /*#__PURE__*/ React.createElement("path", {
      d: "M28.0975 2.24622H17.9748V18.7572H28.0975V2.24622Z",
      fill: "#FF5F00",
    }),
    /*#__PURE__*/ React.createElement("path", {
      d: "M18.9961 10.5018C18.9968 7.28386 ...",
      fill: "#EB001B",
    }),
    /*#__PURE__*/ React.createElement("path", {
      d: "M40 10.5018C40.0029 14.5198 ...",
      fill: "#F79E1B",
    })
  );
}

const ForwardRef = /*#__PURE__*/ React.forwardRef(SvgMastercard);
export default ForwardRef;
export { ForwardRef as ReactComponent };